
import { useState } from "react"
import styled from "styled-components"
import InputText from "../../shared/input/new/InputText"
import Btn from "../../shared/button/Btn"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { showModal } from "../../../features/modal/modalSlice"
import InputDate from "../../shared/input/new/InputDate"
import InputTextarea from "../../shared/input/new/InputTextarea"
import InputCityTown from "../../shared/input/new/InputCityTown"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputSelectMultiple from "../../shared/input/new/InputSelectMultiple"
import ehliyetOptions from "../../../utils/ehliyetOptions"
import srcOptions from "../../../utils/srcOptions"
import PageTopTitle from "../../shared/PageTopTitle"
import { updateAdminUye } from "../../../features/admin2/admin2Slice"
import moment from "moment"
import InputSelect from "../../shared/input/new/InputSelect"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import locationData from "../../../utils/locationData/locationOptions"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 900px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 40px 0 20px;
            width: 900px;
            display: flex;
            flex-direction: column;
            align-items: center;
            max-height: 600px;
            overflow: auto;

            .input-grp{
                display: flex;
                align-items: flex-start;
                flex-direction: column;
                gap: 5px;
                margin-bottom: 20px;

                &:first-child{
                    flex-direction: row;
                    justify-content: space-between;
                    gap: 20px;
                    padding-bottom: 10px;
                    border-bottom: 2px solid ${({theme}) => theme.mainBorderColor};
                }

                .input-column{
                    display: flex;
                    flex-direction: column;
                    gap: 5px;
                }

                input{
                    border: 1px solid ${({theme}) => theme.mainBorderColor};
                    border-radius: 5px;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                }

                p{
                    font-size: 10px;
                    color: var(--color-main);
                }

            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin-bottom: 30px;
            gap: 40px;
        }
    }
`

const kolayAdresTypes = [
    {
        id: 1,
        text: "TC No"
    },
    {
        id: 2,
        text: "Telefon"
    },
    {
        id: 3,
        text: "Vergi No"
    },
    {
        id: 4,
        text: "Pasaport No"
    },
    {
        id: 5,
        text: "Mail"
    },
]



const eYurtKayitliMiOptions = [
    {
        value: true,
        text: "Evet"
    },
    {
        value: false,
        text: "Hayır"
    }
]

const AdminUyeGuncelleModal = () => {

    const { lockScroll, unlockScroll } = useScrollLock();
    const {modalLocation } = useSelector(state => state.modal)
    const {uyeItemData, isLoadingUpdateAdminUye} = useSelector(state => state.admin2)

    const location = useLocation()
    const dispatch = useDispatch()

    const [isSubmitted, setIsSubmitted] = useState(false)

    const ehliyets = uyeItemData.ehliyetTypes.map(item => item.ehliyet)
    const srcs = uyeItemData.srcTypes.map(item => item.srcBelgesi)



    const [ehliyetTypes, setEhliyetTypes] = useState(ehliyetOptions.filter(item => ehliyets?.includes(item.value)))
    const [eYurtKayitliMi, setEYurtKayitliMi] = useState(eYurtKayitliMiOptions.find(item => item.value === uyeItemData.isEgeYurt))
    const [srcTypes, setSrcTypes] = useState(srcOptions?.filter(item => srcs?.includes(item.value)))
    const [kolayAdresType, setKolayAdresType] = useState(kolayAdresTypes.find(item => item.text === uyeItemData?.kolayAdresType))
    const [cityTown ,setCityTown] = useState(locationData?.find(item => item.city === uyeItemData?.il && item.town === uyeItemData?.ilce))
    const [formData, setFormData] = useState({
        tcNo: uyeItemData?.tckn,
        adSoyad: uyeItemData?.adSoyadUnvan,
        dogumTarihi: uyeItemData?.dogumTarihi,
        phoneNumber: uyeItemData?.phoneNumber,
        iban: uyeItemData?.iban,
        adres: uyeItemData?.adres,
        firmaKooperatif:uyeItemData?.kooperatif,
        bankaBilgisiHesapSahibi: uyeItemData?.bankaBilgisiHesapSahibi,
        eYurtNo: uyeItemData?.eyurtNumber,
        kolayAdres: uyeItemData?.kolayAdres,
        kooperatifUyelikTarihi:moment(uyeItemData?.kooperatifUyelikTarihi)?.format('YYYY-MM-DD')
    })

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleChange = (e, isNumber) => {
        if(isNumber){
            setFormData((prev) => ({ ...prev, [e?.target?.name]: e?.target?.value.replace(/[^0-9]/g, '')}))
        }
        else{
            setFormData((prev) => ({ ...prev, [e?.target?.name]: e?.target?.value }))
        }
    }

    const handleSubmit = () => {
        setIsSubmitted(true)

        if(formData.tcNo && formData.phoneNumber && formData.adSoyad && formData.adres && cityTown?.location && ehliyetTypes.length > 0 && srcTypes.length > 0){


            const data = {
                phoneNumber: formData.phoneNumber,
                tckn: formData.tcNo,
                adSoyadUnvan: formData.adSoyad,
                dogumTarihi: formData.dogumTarihi,
                adressContent: formData.adres,
                bankaBilgisiHesapSahibi: formData.bankaBilgisiHesapSahibi,
                iban: formData.iban,
                kolayAdresType: kolayAdresType?.text,
                kolayAdres:formData.kolayAdres,
                kooperatif: formData.firmaKooperatif,
                kooperatifUyelikTarihi: formData?.kooperatifUyelikTarihi !== "Invalid date" ? formData?.kooperatifUyelikTarihi : null,
                isEgeYurt: eYurtKayitliMi?.value,
                eyurtKayıtTarihi: formData?.eyurtKayitTarihi !== "Invalid date" ? formData?.eyurtKayitTarihi : null,
                eyurtNumber: parseInt(formData.eYurtNo) || 0

            }
            dispatch(updateAdminUye(
                {
                    ...data,
                    id:uyeItemData.id,
                    il: cityTown.city,
                    ilce: cityTown.town,
                    srcTypes: srcTypes.map(item => {
                        return {srcBelgesi: item.value}
                    }),
                    ehliyetTypes: ehliyetTypes.map(item => {
                        return {ehliyet: item.value}
                    })
                }
            ))
        }
    }

  return (
    <ModalContainer>
        <div className="modal" onClick={() => dispatch(handleActiveSelect(null))}>
            <PageTopTitle title={"Üye Güncelle"}/>
            <div className="content">
                <div className="input-grp">
                    <div className="input-column">
                        <InputText data={formData.phoneNumber} setData={(e) =>handleChange(e, true)} inputWidth={"210px"} labelText="Telefon Numarası" name={"phoneNumber"}/>
                        {
                            (!formData.phoneNumber && isSubmitted) &&
                            <p>Telefon bilgisi girilmesi zorunludur</p>
                        }
                    </div>
                    <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"210px"} >Cep Telefonunu Kontrol Et</Btn>
                </div>
                <div className="input-grp">
                    <InputText data={formData.tcNo} setData={(e) =>handleChange(e, true)} inputWidth={"440px"} labelText="TC No" name={"tcNo"}/>
                    {
                        (!formData.tcNo && isSubmitted) &&
                        <p>TC No bilgisi girilmesi zorunludur</p>
                    }
                </div>
                <div className="input-grp">
                    <InputText data={formData.adSoyad} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Adı Soyadı" name={"adSoyad"}/>
                    {
                        (!formData.adSoyad && isSubmitted) &&
                        <p>Ad Soyad bilgisi girilmesi zorunludur</p>
                    }
                </div>
                <div className="input-grp">
                    <InputDate data={formData.dogumTarihi} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Doğum Tarihi" name={"dogumTarihi"}/>
                </div>
                <div className="input-grp">
                    <InputTextarea data={formData.adres} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Adres" name={"adres"}/>
                    {
                        (!formData.adres && isSubmitted) &&
                        <p>Adres bilgisi girilmesi zorunludur</p>
                    }
                </div>
                <div className="input-grp">
                    <InputCityTown data={cityTown?.location} setData={setCityTown} inputWidth={"440px"} labelText="İl/İlçe" name={"cityTown"}/>
                    {
                        (!cityTown?.location && isSubmitted) &&
                        <p>İl/İlçe bilgisi girilmesi zorunludur</p>
                    }
                </div>
                <div className="input-grp">
                    <InputSelectMultiple data={ehliyetTypes} setData={setEhliyetTypes} inputWidth={"440px"} labelText="Ehliyet Türleri" name={"ehliyetTypes"} options={ehliyetOptions}/>
                    {
                        (ehliyetTypes < 1 && isSubmitted) &&
                        <p>Ehliyet bilgisi girilmesi zorunludur</p>
                    }
                </div>
                <div className="input-grp">
                    <InputSelectMultiple data={srcTypes} setData={setSrcTypes} inputWidth={"440px"} labelText="SRC Türü" name={"srcTypes"} options={srcOptions}/>
                    {
                        (srcTypes.length < 1 && isSubmitted) &&
                        <p>SRC bilgisi girilmesi zorunludur</p>
                    }
                </div>
                <div className="input-grp">
                    <InputText data={formData.bankaBilgisiHesapSahibi} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Banka Bilgisi Hesap Sahibi" name={"bankaBilgisiHesapSahibi"}/>
                </div>
                <div className="input-grp">
                    <InputText data={formData.iban} setData={(e) =>handleChange(e, true)} inputWidth={"440px"} labelText="İban" name={"iban"}/>
                </div>
                <div className="input-grp">
                    <InputSelect data={kolayAdresType?.text} setData={setKolayAdresType} inputWidth={"440px"} labelText="Kolay Adres Türü" name={"kolayAdresType"} initialOptions={kolayAdresTypes}/>
                </div>
                <div className="input-grp">
                    <InputText data={formData.kolayAdres} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Kolay Adres" name={"kolayAdres"}/>
                </div>
                <div className="input-grp">
                    <InputText data={formData.firmaKooperatif} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Firma - Kooperatif" name={"firmaKooperatif"}/>
                </div>
                <div className="input-grp">
                    <InputDate data={formData.kooperatifUyelikTarihi} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Kooperatif Üyelik Tarihi" name={"kooperatifUyelikTarihi"}/>
                </div>
                <div className="input-grp">
                    <InputSelect data={eYurtKayitliMi?.text} setData={setEYurtKayitliMi} inputWidth={"440px"} labelText="E-Yurt Kayıtlı Mı?" name={"eYurtKayitliMi"} initialOptions={eYurtKayitliMiOptions}/>
                </div>
                {
                    eYurtKayitliMi?.value &&
                    <>
                        <div className="input-grp">
                            <InputText data={formData.eYurtNo} setData={(e) =>handleChange(e, true)} inputWidth={"440px"} labelText="E-Yurt Müşteri ID" name={"eYurtNo"}/>
                        </div>
                        <div className="input-grp">
                            <InputDate data={formData.eyurtKayitTarihi} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="E-Yurt Kayıt Tarihi" name={"eyurtKayitTarihi"}/>
                        </div>
                    </>
                }
                {/* <div className="input-grp">
                    <InputDate data={formData.uyeKayitTarihi} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Üye Kayıt Tarihi" name={"uyeKayitTarihi"}/>
                </div> */}
            </div>

            <div className="button-grp">
                <Btn width={"240px"} bgColor="#E85446" color="#fff" handleClick={handleSubmit}>{isLoadingUpdateAdminUye ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Güncelle"}</Btn>
                <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
            </div>
        </div>
    </ModalContainer>
  )
}

export default AdminUyeGuncelleModal